import React, { Component } from "react";
import { Layout, BackTop, Spin } from "antd";
import { FormattedMessage } from "react-intl";

import Topmenu from "../../components/menu/topmenu";
import { siteConfig } from "../../settings/config";
import TopbarViewWrapper from "./topbar.style";

import { withTheme } from "styled-components";

import Nprogress from "nprogress";
import ErrorBoundary from "../../helpers/errorBoundary";
import AppContext from "../../AppContext";

const { Content, Footer } = Layout;

export class TopbarView extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  componentWillUnmount() {
    Nprogress.start();
  }

  async componentDidMount() {
    if (!this.props.layout && this.context.appLayout !== "topbar") {
      await this.context.updateLayout("topbar");
    }
    Nprogress.done();
  }

  render() {
    return this.props.layout ? (
      <Spin spinning={this.state.isLoading}>
        <TopbarViewWrapper>
          <Layout id="main-layout" className="topbarViewContainer">
            <BackTop />
            <Layout className="topbarViewLayout">
              <Topmenu />
              <Layout id="content-main-layout" className="topbarViewContentLayout">
                <BackTop target={() => document.getElementById("content-main-layout")} />
                <Content id="content-main" className="topbarViewContent antSpinFillParent">
                  <ErrorBoundary>{this.props.children}</ErrorBoundary>
                  <Footer className="topbarViewContentFooter">
                    <FormattedMessage id={siteConfig.footerText} />
                  </Footer>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </TopbarViewWrapper>
      </Spin>
    ) : (
      this.props.children
    );
  }
}

export default withTheme(TopbarView);
